import { theme } from '@sinohealth/butterfly-ui-components';

const useThemeToken = () => {
  const { useToken } = theme;
  const { token } = useToken();
  return token;
};

export default useThemeToken;
